<template>
    <div id="app">
       
        <!-- <div class="header">
           
        </div> -->
        <div class="container" style="clear: both;">
            <router-view></router-view>
        </div>

        <!-- <div style="width: 90%;margin: 20px auto;">
            <div style="height:1px;padding:0;background-color:#999;">
            </div>
        </div> -->
        <div class="footer">
            <!-- <div class="join">
                <h2>加盟到家旅居</h2>
                <div class="join_form">
                    <input type="text" placeholder="输入姓名">
                    <input style="flex:1" type="text" placeholder="输入联系方式">
                    <div>提交申请</div>
                </div>

            </div> -->
            <el-row :gutter="108">
                <el-col :xs="24" :sm="6" justify="start" align="top">
                    <div class="footer_font footer_class">到家旅居小程序</div>
                    <div><img src="../../static/layout/mpWeixin.jpg" style="width: 126px;height: 126px;border: 0" /></div>

                </el-col>
                <el-col :xs="24" :sm="6" justify="start" align="top">
                    <div class="footer_font footer_class">到家旅居APP-安卓</div>
                    <div><img src="../../static/layout/app.png" style="width: 126px;height: 126px;border: 0" /></div>

                </el-col>
                <el-col :xs="24" :sm="6">
                    <div class="footer_font footer_class">关于我们</div>
                    <div class="footer_text">到家旅居平台，由湖南到家旅居康养文化旅游运营股份有限公司创立，是一家专注于为休闲、文旅、商务和康养用户提供全新生活方式的高品质平台。
                    </div>
                </el-col>
                <el-col :xs="24" :sm="6">
                    <div class="footer_font footer_class">联系方式</div>
                    <div class="footer_text">地址：湖南省长沙市天心区新开铺路688号<br />
                        商务合作：17673049133
                    </div>
                </el-col>
            </el-row>
            <div class="footer_number">
                <div> Copyright©2022 湖南·到家旅居 版权所有 
                    
                    <a href="https://beian.miit.gov.cn/" target="_blank"
                    rel="noopener noreferrer">备案号:湘ICP备2022001244号-1</a>
                    
                技术支持:到家旅居网络技术服务部</div>
                <div style="display: flex;
align-items: center; justify-content: center;">
                    <img src="../../static/layout/beian.png" alt="">
                    <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43010302001720" target="_blank"
                        rel="noopener noreferrer">湘公网安备 43010302001720号</a>
                </div>

            </div>
        </div>
        <!-- <div id="back_to_top" ref="btn" @click="backTop" style="display: none;">
            <p style="font-size: 0.625em; font-weight: bold">TOP</p>
            <img src="../assets/other/launch.png" style="height: 45px;width: 35px" />
        </div> -->
    </div>
</template>

<script>
import {test} from "../api/layout/index.js";

export default {

    name: "Layout",
    data() {
        return {
            activeIndex: '1',
            // company:{
            //     qrcode: require("../../static/other/公众号二维码.jpg"),
            // },
            scroll: '',
            timer: '',
            seen: true,
            currentMenu: '首页',
            popupShow:false
        };
    },
    methods: {
        httpTest() {
    test({a:1}).then(res => {
      console.log(res)
    })
  }
        // handleSelect(key) {
        //     switch (key){
        //         case '1':
        //             this.$router.push({name: "Index"});
        //             break;
        //         case '2-1':
        //             window.location.hash = "#产品微观";
        //             break;
        //         case '2-2':
        //             this.$router.push({name: "Fruit"});
        //             break;
        //         case '2-3':
        //             this.$router.push({name: "Fashion"});
        //             break;
        //         case '3':
        //             this.$router.push({name: "Index"});
        //             window.location.hash = "#产品特点";
        //             break;
        //         case '4':
        //             this.$router.push({name: "Index"});
        //             window.location.hash = "#合作伙伴";
        //             break;
        //         case '5':
        //             this.$router.push({name: "Index"});
        //             window.location.hash = "#关于我们";
        //             break;
        //     }
        // },
        // handleSelectMobile(key) {
        //     switch (key){
        //         case '1':
        //             this.$router.push({name: "Index"});
        //             this.currentMenu='首页';
        //             break;
        //         case '2-1':
        //             this.$router.push({name: "Index"});
        //             window.location.hash = "#产品微观";
        //             this.currentMenu='首页';
        //             break;
        //         case '2-2':
        //             this.$router.push({name: "Fruit"});
        //             this.currentMenu='生鲜果蔬';
        //             break;
        //         case '2-3':
        //             this.$router.push({name: "Fashion"});
        //             break;
        //         case '3':
        //             this.$router.push({name: "Index"});
        //             window.location.hash = "#产品特点";
        //             this.currentMenu='首页';
        //             break;
        //         case '4':
        //             this.$router.push({name: "Index"});
        //             window.location.hash = "#合作伙伴";
        //             this.currentMenu='首页';
        //             break;
        //         case '5':
        //             this.$router.push({name: "Index"});
        //             window.location.hash = "#关于我们";
        //             this.currentMenu='首页';
        //             break;
        //     }
        // },
        // handleScroll(){
        //     this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
        //     if( this.scroll >600 ){  //判断滚动后高度超过400px,就显示
        //         this.$refs.btn.style.display = 'block';
        //     }else{
        //         this.$refs.btn.style.display = 'none'
        //     }
        // },
        // backTop(){ //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
        //     this.timer = setInterval(() => {
        //         let osTop = document.documentElement.scrollTop || document.body.scrollTop;
        //         let ispeed = Math.floor(-osTop / 5)
        //         document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        //         if (osTop === 0) {
        //             clearInterval(this.timer)
        //         }
        //     }, 30)
        // },
        // login(){
        //     window.open('https://admin.fastice-tech.com/login')
        // },
        // register(){
        //     window.open('https://admin.fastice-tech.com/registe')
        // },
        // menuSeen(){
        //     // 屏幕尺寸
        //     let screenHeight=document.body.clientWidth;
        //     if(screenHeight>415){
        //         this.seen=true;
        //     }else{
        //         this.seen=false;
        //     }
        // },
        // logoClick(){
        //     this.$router.push({name: "Index"});
        //     this.currentMenu='首页';
        // }
    },
    mounted() {
        // this.httpTest()
        // this.menuSeen()
        // window.addEventListener('scroll', this.handleScroll)
    },
}
</script>

<style scoped>
#app {
    overflow-x: hidden;
}

.logo_img {
    float: left;
    width: 30%;
    cursor: pointer;
}

#back_to_top {
    position: fixed;
    bottom: 50px;
    right: 30px;
    cursor: pointer
}

.header-title {
    font-size: 1em;
}

.company_name {
    font-weight: normal;
    font-size: 1em;
}

.footer_font {
    font-size: 1em;

}

.footer_class {
    margin-bottom: 44px;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 25px;

}

.footer_text {
    width: 168px;
    height: 140px;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.4);
    line-height: 20px;
}

#menu_index {
    float: left;
    width: 50%;
    height: 100%
}

.header {
    /* margin: auto;
        width: 90%;
        height: 65px; */
    /*background: #F56C6C;*/
}

@media screen and (max-device-width: 415px) {
    .logo_img {
        float: left;
        width: auto;
        cursor: pointer;
    }

    #back_to_top {
        position: fixed;
        bottom: 50px;
        right: 5px;
        cursor: pointer
    }

    .footer_font {
        font-size: 0.875em;
    }

    #menu_index {
        float: right;
        width: auto;
        height: 100%
    }

    .mobile_menu {}
}

#header-img {
    width: 50px;
    height: 50px;
    float: left;
    margin: auto;
}

.header-logo {
    height: 50px;
    width: 50px;
    align-self: center;
}

.header-important {
    float: left;
    margin-left: 6px;
    align-self: center;
}

.footer {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90%;
    width: 100%;
    height: 725px;
    background: #232831;
    flex-direction: column;
    position: relative;
}

.footer_number {
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.4);
    line-height: 22px;
    margin-top: 131px;
    text-align: center;

}

.footer_number img {
    width: 16px;
    height: 16px;
}

.footer_number a {
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.4);
    line-height: 22px;
    text-align: center;
}

a {
    text-decoration: none;
}

a:visited {
    text-decoration: none;
}

a:hover {
    text-decoration: none;
}

a:active {
    text-decoration: none;
}

.join {
    position: absolute;
    top: -129px;
    width: 949px;
    height: 259px;
    background: #FFFFFF;
    padding: 36px 115px;
    box-sizing: border-box;
    text-align: center;
}

.join h2 {
    font-size: 44px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 62px;
    padding-bottom: 25px;
}

.join_form {

    width: 719px;
    height: 71px;
    background: #F2F2F2;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.join_form input {
    text-indent: 20px;
    background: #F2F2F2;

    color: #999999;
}

.join_form div {

    border-radius: 0 8px 8px 0;
    width: 129px;
    height: 100%;
    background: #FB4164;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 71px;
    cursor: pointer;
}


</style>